import React, {useEffect} from "react";
import Navbar from "./Components/navbar";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Inicio from "./Pages/inicio";
import Contacto from "./Pages/contact";
import Servicios from "./Pages/servicios";
import Testimonios from "./Pages/Testimonios";
import Chatbot from "./Components/chatbot";
import "./App.css";
import About from "./Pages/about";
import Footer from "./Components/footer";

function MainLayout() {
  const location = useLocation();
  const showFooter = ["/servicios", "/contact", "/about"].includes(
    location.pathname
  );

    // Cambia de ruta sin recargar la página
    useEffect(() => {
      window.scrollTo({
        behavior: 'smooth'
    }, 0.5);
    }, [location.pathname]); // Se ejecuta cuando cambia la ruta

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Inicio />} />
        <Route path="/servicios" element={<Servicios />} />
        <Route path="/contact" element={<Contacto />} />
        <Route path="/about" element={<About />} />
        <Route path="/testimonios" element={<Testimonios/>} />
      </Routes>
      <Chatbot />
      {showFooter && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="*" element={<MainLayout />} />
      </Routes>
    </Router>
  );
}

export default App;
